import Vue from 'vue/dist/vue.min.js'
import vSelect from 'vue-select'


window.Vue = require('vue').default;

Vue.component(
    "app",
    require("./components/App.vue").default
);
Vue.component('home-component', require('./components/HomeComponent.vue').default);
Vue.component('create-client-model-component', require('./components/CreateClientModelComponent.vue').default);
//Vue.component('gallery-component', require('./components/GalleryComponent.vue').default);
Vue.component('request-design-component', require('./components/RequestComponent.vue').default);
// Vue.component('show-detail-model-component', require('./components/DetailCardModelComponent.vue').default);
Vue.component('details-model-component', require('./components/model/DetailsModelComponent.vue').default);
Vue.component('v-select', vSelect);
Vue.component('loader', require('./components/TheLoaderComponent.vue'));
Vue.component('order-component', require('./components/OrderComponent.vue').default);
Vue.component('order-detail-component', require('./components/OrderDetailComponent.vue').default);
Vue.component('question-component', require('./components/QuestionComponent.vue').default);
//Vue.component('faqs-component', require('./components/FaqsComponent.vue').default);
//Vue.component('privacy-component', require('./components/PrivacyPolicyComponent.vue').default);
//Vue.component('term-of-service-component', require('./components/TermOfServiceComponent.vue').default);
//Vue.component('submit-material-component', require('./components/SubmitMaterialComponent.vue').default);
Vue.component('cart-component', require('./components/CartComponent.vue').default);
Vue.component('wishlist-component', require('./components/WishlistComponent.vue').default);
Vue.component('model-3d-preview-component', require('./components/Model3DPreviewComponent.vue').default);
//Vue.component('modal-model-3d-preview-component', require('./components/ModalModel3dPreviewComponent.vue').default);
Vue.component('users-model-gallery-component', require('./components/UsersModelGalleryComponent.vue').default);
//Vue.component('users-model-component', require('./components/UsersModelComponent.vue').default);

// new Vue({
//   el: '#app',
//   render: h => h(App)
// });

Vue.prototype.window = window;

if ($('#user-app').length) {
    const userApp = new Vue({
        el: '#user-app',
    });
}

